import { NextRouter } from 'next/router'
import { useLocalObservable } from 'mobx-react-lite'
import { Page, updatePageChangedWithRouterEvent } from './page'

export const useUpdateRouterHistory = ({
	router,
	defaultPageLimit,
}: {
	defaultPageLimit: number
	router: NextRouter
}) => {
	const store = useLocalObservable(() => ({
		filterType: 'all',
		filter: {},
		paging: Page({ pageSize: defaultPageLimit }),

		// 업데이트 할 때, 항상 실행 할 것
		invalidate: (forceParams?: Record<string, any>, isReplace: boolean = false) => {
			if (forceParams) {
				updatePageChangedWithRouterEvent(forceParams, router, isReplace)
			} else {
				const params: Record<string, any> = {
					...store.filter,
					offset: store.paging.offset,
					limit: store.paging.limit,
				}
				updatePageChangedWithRouterEvent(params, router, isReplace)
			}
		},

		updatePagination: (offset: number, limit?: number) => {
			store.paging.setCurrent(offset, limit ?? defaultPageLimit)
		},

		updateFilterSearch(name: string, value: string | string[]) {
			const newFilter = {
				...store.filter,
			}
			newFilter[name] = value
			store.filter = newFilter
		},

		deleteFilterSearch(name: string) {
			delete store.filter[name]
		},

		clearAllFilterSearch() {
			store.filter = {}
		},

		clearAll() {
			this.clearAllFilterSearch()
			this.updatePagination(0)
		},

		updateFilterSearchType(searchType: string) {
			store.filterType = searchType

			if (searchType !== 'all') {
				const [category, value] = searchType.split('/')
				store.filter[category] = value.toString()
			} else {
				store.clearAllFilterSearch()
			}
		},
	}))

	return store
}
